var _style, _metadata, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCt8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7F3C6;stroke:#231F20;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 44,
    width: 44,
    x: 0,
    y: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.6,16.3c0-1,0.3-2,0.9-2.9s1.4-1.7,2.5-2.2s2.4-0.8,3.9-0.8c1.2,0,2.3,0.2,3.3,0.5s1.7,0.8,2.3,1.3 s1.1,1.2,1.4,1.9s0.5,1.5,0.5,2.3c0,1-0.3,1.9-0.8,2.7s-1.3,1.5-2.4,2c0.9,0.3,1.6,0.8,2.2,1.4s1,1.2,1.3,1.9s0.5,1.5,0.5,2.5 c0,1.3-0.3,2.5-1,3.6s-1.6,1.9-2.8,2.5s-2.7,0.9-4.3,0.9s-3.2-0.3-4.4-0.9s-2.2-1.4-2.8-2.5s-0.9-2.2-0.9-3.5c0-2.8,1.3-4.7,4-5.8 C15.7,20,14.6,18.4,14.6,16.3z M25.8,26.6c0-0.8-0.2-1.5-0.5-2.1s-0.8-1.1-1.4-1.4s-1.3-0.5-2-0.5c-1.1,0-2,0.4-2.7,1.1 s-1.1,1.7-1.1,3c0,0.8,0.2,1.5,0.5,2.1s0.8,1.1,1.4,1.4s1.2,0.5,2,0.5s1.4-0.2,2-0.5s1-0.8,1.4-1.5S25.8,27.4,25.8,26.6L25.8,26.6z  M21.9,13.3c-1,0-1.8,0.3-2.4,0.9s-0.9,1.4-0.9,2.4c0,0.9,0.3,1.6,0.9,2.2s1.4,0.9,2.4,0.9c0.5,0,0.9-0.1,1.3-0.2s0.7-0.4,1-0.6 s0.5-0.6,0.7-1s0.2-0.8,0.2-1.3c0-0.6-0.1-1.2-0.4-1.7s-0.7-0.9-1.2-1.2S22.6,13.3,21.9,13.3L21.9,13.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt8);
export default __webpack_public_path__ + "static/media/CT8.c730864bb8587558b19e6aa7e413ee67.svg";
export { ForwardRef as ReactComponent };